
import React, { FunctionComponent, } from 'react';

import {
  CheckCircle,
} from '@mui/icons-material';
import {
  Grid,
} from '@mui/material';

import { useTranslation } from 'react-i18next';

import './SuccessMessage.css';

interface Props {
  header?: string,
}

const SuccessMessage: FunctionComponent<Props> = ( props ) => {

  const { t } = useTranslation( [ 'successMessage' ] );

  return (
    <div className="success-message">
      <Grid container gap={ 2 }>
        <Grid item xs={12}>
          <Grid container justifyContent={'center'}>
          </Grid>
          <h2>
            { props.header ? props.header : t( 'Success' ) }
            <CheckCircle sx={{ color: 'var(--hgs-primary)', fontSize: '1.5em', }}/>
          </h2>
          { props.children ? props.children : (
            <div>
              <p>Your data has been confirmed.</p>
              From now please login with the email address and your password.
            </div>
          )}
        </Grid>
      </Grid>
    </div>
  );

}

export default SuccessMessage;
